export default "__VITE_ASSET__CY5xw9kI__"